import Lenis from 'lenis';

export default class Scroll {
    constructor(element) {
        if (!element) return;

        this.element = element;
        this.lenis = null;
        this.rafId = null;
        this.anchorHandlers = [];
        this.render = this.render.bind(this);

        this.init();
    }

    init() {
        this.lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            direction: 'vertical',
            gestureDirection: 'vertical',
            smoothWheel: true,
            touchMultiplier: 0.2,
            infinite: false,
        });

        this.rafId = requestAnimationFrame(this.render);
        this.setupEvents();
    }

    render(time) {
        if (!this.lenis) return;

        this.lenis.raf(time);
        this.rafId = requestAnimationFrame(this.render);
    }

    setupEvents() {
        document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
            const handler = (e) => {
                const href = anchor.getAttribute('href');

                if (!href || href === '#') return;

                const targetId = decodeURIComponent(href.slice(1));
                const target = document.getElementById(targetId);

                if (!target || !this.lenis) return;

                e.preventDefault();
                this.lenis.scrollTo(target);
            };

            anchor.addEventListener('click', handler);
            this.anchorHandlers.push({ anchor, handler });
        });
    }

    stop() {
        if (this.lenis) {
            this.lenis.stop();
        }
    }

    start() {
        if (this.lenis) {
            this.lenis.start();
        }
    }

    destroy() {
        if (this.rafId) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
        }

        this.anchorHandlers.forEach(({ anchor, handler }) => {
            anchor.removeEventListener('click', handler);
        });
        this.anchorHandlers = [];

        if (this.lenis) {
            this.lenis.destroy();
            this.lenis = null;
        }
    }
}